import React, { useState } from 'react';
import {
    Box,
    Typography
} from '@mui/material';
import GamemasterProvider from './Pages/Provider/GamemasterProvider';
import GamemasterSportSelection from './Pages/SprotsSelection/GamemasterSportSelection';
import GamemasterSportRanking from './Pages/SportRanking/GamemasterSportRanking';
import GamemasterOptions from './Pages/Options/GamemasterOptions';
import GamemasterUserDevices from './Pages/UserDevices/GamemasterUserDevices';
import ScreenSetting from './Pages/ScreenSetting/ScreenSetting';
import { usePermissionCheck } from 'core/hooks/usePermissionCheck';
import { useResetSettingsScroll } from '../../utils/resetSettingsScroll';

const GameMasterSetting = () => {
    console.log(process.env.REACT_APP_ADMIN_API_URL, "line 14");
    const { hasViewPermission, hasEditPermission, hasDeletePermission, hasExecutePermission } = usePermissionCheck();
    const canViewGameMaster = hasViewPermission('GameMaster');
    const canEditGameMaster = hasEditPermission('GameMaster');
    const canDeleteGameMaster = hasDeletePermission('GameMaster');
    const canExecuteGameMaster = hasExecutePermission('GameMaster');
    const [providerViewMode, setProviderViewMode] = useState<'list' | 'create' | 'edit' | 'view'>('list');
    const [deviceViewMode, setDeviceViewMode] = useState<'list' | 'create' | 'show' | 'edit'>('list');
    const [optionsViewMode, setOptionsViewMode] = useState<'list' | 'edit'>('list');
    const [screenGroupViewMode, setScreenGroupViewMode] = useState<'list' | 'create' | 'editItem' | 'edit'>('list');
    const [sportSelectionViewMode, setSportSelectionViewMode] = useState<'list' | 'edit'>('list');
    const [sportRankingViewMode, setSportRankingViewMode] = useState<'list' | 'edit'>('list');

    // Hide other components when provider, device, options, screenGroup, sportSelection, or sportRanking is in create/edit/view mode
    const shouldHideOtherComponents =
        providerViewMode !== 'list' ||
        deviceViewMode !== 'list' ||
        optionsViewMode !== 'list' ||
        screenGroupViewMode !== 'list' ||
        sportSelectionViewMode !== 'list' ||
        sportRankingViewMode !== 'list';

    useResetSettingsScroll(
        `${providerViewMode}|${deviceViewMode}|${optionsViewMode}|${screenGroupViewMode}|${sportSelectionViewMode}|${sportRankingViewMode}`
    );

    if (!canViewGameMaster) {
        return (
            <Box sx={{ p: 4 }}>
                <Typography variant="body2" color="textSecondary" align="center">
                    You do not have permission to view GameMaster settings.
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={shouldHideOtherComponents ? { p: 0 } : { p: { xs: 2, md: 4 } }}>
            {/* Header */}
            <Typography variant="h4" gutterBottom style={{ display: shouldHideOtherComponents ? 'none' : 'block' }}>
                GameMaster
            </Typography>
            <Typography variant="body2" sx={{ maxWidth: 600, mb: 3, display: shouldHideOtherComponents ? 'none' : 'block' }}>
                
            </Typography>
            <Box style={{ display: providerViewMode !== 'list' ? 'block' : (shouldHideOtherComponents ? 'none' : 'block') }}>
                <GamemasterProvider
                    onViewModeChange={setProviderViewMode}
                    canEdit={canEditGameMaster}
                    canDelete={canDeleteGameMaster}
                    canExecute={canExecuteGameMaster}
                />
            </Box>
            <Box style={{ display: screenGroupViewMode !== 'list' ? 'block' : (shouldHideOtherComponents ? 'none' : 'block') }}>
                <ScreenSetting
                    onViewModeChange={setScreenGroupViewMode}
                    canEdit={canEditGameMaster}
                    canDelete={canDeleteGameMaster}
                    canExecute={canExecuteGameMaster}
                />
            </Box>
            <Box style={{ display: sportSelectionViewMode !== 'list' ? 'block' : (shouldHideOtherComponents ? 'none' : 'block') }}>
                <GamemasterSportSelection
                    onViewModeChange={setSportSelectionViewMode}
                    canEdit={canEditGameMaster}
                />
            </Box>
            <Box style={{ display: sportRankingViewMode !== 'list' ? 'block' : (shouldHideOtherComponents ? 'none' : 'block') }}>
                <GamemasterSportRanking
                    onViewModeChange={setSportRankingViewMode}
                    canEdit={canEditGameMaster}
                />
            </Box>
            {/* Hide Options when device or screenGroup is in create/edit/show mode */}
            <Box style={{ display: optionsViewMode !== 'list' ? 'block' : (shouldHideOtherComponents ? 'none' : 'block') }}>
                <GamemasterOptions onViewModeChange={setOptionsViewMode} canEdit={canEditGameMaster} />
            </Box>
            {/* Hide Devices when options or screenGroup is in edit mode */}
            <Box style={{ display: deviceViewMode !== 'list' ? 'block' : (shouldHideOtherComponents ? 'none' : 'block') }}>
                <GamemasterUserDevices
                    onViewModeChange={setDeviceViewMode}
                    canEdit={canEditGameMaster}
                    canDelete={canDeleteGameMaster}
                    canExecute={canExecuteGameMaster}
                />
            </Box>
        </Box>
    );
};

export default GameMasterSetting;
